import { render, staticRenderFns } from "./TreeSelectWidget.vue?vue&type=template&id=a3f72f02&"
import script from "./TreeSelectWidget.vue?vue&type=script&lang=js&"
export * from "./TreeSelectWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports